interface BubbleProps {
  text: string | React.ReactNode;
  gradientDirection: 'left' | 'right' | 'center';
  className?: string;
  textClassName?: string;
  /** 꼬리 방향: 기본 bottom(기존 디자인 유지), 좌우로 붙일 때 left/right */
  tailSide?: 'bottom' | 'left';
  /** 그라디언트 대신 단색 배경을 강제로 적용할 때 사용 */
  solidBgClassName?: string;
  /** 꼬리 색상을 Tailwind 텍스트 컬러 클래스 등으로 지정(예: 'text-text-main-lv2') */
  tailColorClassName?: string;
}

const Bubble = ({
  text,
  gradientDirection,
  className = '',
  textClassName = '',
  tailSide = 'bottom',
  solidBgClassName,
  tailColorClassName
}: BubbleProps) => {
  const bgColor =
    gradientDirection === 'right' || gradientDirection === 'center'
      ? 'bg-[linear-gradient(90deg,#FF45A9_0%,#FF6A6A_100%)]'
      : 'bg-[linear-gradient(266deg,#FF45A9_3.39%,#FF6A6A_103.54%)]';

  const containerBgClass = solidBgClassName ?? bgColor;

  const tailPositionClass =
    tailSide === 'bottom'
      ? `bottom-[-5.5px] ${
          gradientDirection === 'right'
            ? 'right-[10px]'
            : gradientDirection === 'left'
              ? 'left-[10px]'
              : 'left-1/2 -translate-x-1/2'
        }`
      : 'left-[-8px] top-1/2 -translate-y-1/2';
  return (
    <div
      className={`px-[10px] py-[7px] rounded-[4px] w-fit relative ${containerBgClass} ${className}`}
    >
      <p
        className={`text-pure-white text-[12px] font-medium whitespace-nowrap leading-[14px] ${textClassName}`}
      >
        {text}
      </p>
      <div className={`absolute ${tailPositionClass}`}>
        <GradientTail
          direction={gradientDirection}
          side={tailSide}
          fillClassName={tailColorClassName}
        />
      </div>
    </div>
  );
};

export default Bubble;

const GradientTail = ({
  direction,
  side = 'bottom',
  fillClassName,
  fillColor
}: {
  direction: 'left' | 'right' | 'center';
  side?: 'bottom' | 'left';
  /** SVG tail을 currentColor로 칠하고 싶을 때 사용 (예: 'text-text-main-lv2') */
  fillClassName?: string;
  /** 직접 색상을 지정하고 싶을 때 사용 (예: '#ffffff') */
  fillColor?: string;
}) => {
  const clipPathId = `gradient-tail-${direction}-${side}`;
  const rotationClass = side === 'left' ? 'rotate-90' : '';
  const startColor = '#FF45A9';
  const endColor = '#FF6A6A';
  const bottomColor = '#FF696C';
  const tailFillColor =
    side === 'left'
      ? direction === 'right' || direction === 'center'
        ? startColor
        : endColor
      : bottomColor;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      aria-hidden="true"
      className={`${rotationClass} ${fillClassName ?? ''}`}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M5.86816 5.48047C5.48427 6.15228 4.51573 6.15228 4.13184 5.48047L1.54658 0.956478C1.20859 0.365014 0.579589 0 -0.101638 0H-1C-1.55228 0 -2 -0.447715 -2 -1C-2 -1.55228 -1.55228 -2 -1 -2H11C11.5523 -2 12 -1.55228 12 -1C12 -0.447715 11.5523 0 11 0H10.1016C9.42041 0 8.79141 0.365015 8.45342 0.956479L5.86816 5.48047Z"
          fill={fillClassName ? 'currentColor' : (fillColor ?? tailFillColor)}
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="10" height="6" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
